import React from 'react';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./components/secrets";
import ExpenseTracker from './components/ExpenseTracker';
import { UserProvider } from './providers/user';

function App() {
  return (
    <div className="App">
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <UserProvider>
          <ExpenseTracker />
        </UserProvider>
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;